import format from 'string-format';
import tuneInRequest from '../tuneInRequest';
export default function redirectInfoService(config, apiContext) {
    return function getRedirectInfo(guideId) {
        return tuneInRequest({
            method: 'get',
            url: format('{}/profiles/{}', config.domains.api, guideId),
        }, apiContext);
    };
}
